import { createStore } from "vuex";

export default createStore({
  state: {
    companyID: "",
    token: false,
    socketConnected: false,
    trackingStation: null,
    payapVoided: false,
    payap: false,
    payapTimeout: false,
    payapCancel: false,
    payapPaid: false,
    currency: "NZD",
  },
  getters: {
    getCompanyID(state) {
      return state.companyID;
    },
    getToken(state) {
      return state.token;
    },
    socketConnected(state) {
      return state.socketConnected;
    },
    getTrackingStation(state) {
      return state.trackingStation;
    },
    getPayapVoided(state) {
      return state.payapVoided;
    },
    getPayap(state) {
      return state.payap;
    },
    getPayapTimeout(state) {
      return state.payapTimeout;
    },
    getPayapCancel(state) {
      return state.payapCancel;
    },
    getPayapPaid(state) {
      return state.payapPaid;
    },
    currency(state) {
      return state.currency;
    }
  },
  mutations: {
    companyIDMutation(state, payload) {
      state.companyID = payload;
    },
    tokenMutation(state, payload) {
      state.token = payload;
    },
    setSocketConnectedMutation(state, payload) {
      state.socketConnected = payload;
    },
    trackingStationMutation(state, payload) {
      state.trackingStation = payload;
    },
    payapVoidedMutation(state, payload) {
      state.payapVoided = payload;
    },    
    payapMutation(state, payload) {
      state.payap = payload;
    },
    payapTimeoutMutation(state, payload) {
      state.payapTimeout = payload;
    },
    payapCancelMutation(state, payload) {
      state.payapCancel = payload;
    },
    payapPaidMutation(state, payload) {
      state.payapPaid = payload;
      console.log("payapPaidMutation", payload);
    },
    currencyMutation(state, payload) {
      state.currency = payload;
    }
  },
  actions: {
    companyIDAction({ commit }, payload) {
      commit("companyIDMutation", payload);
    },
    tokenAction({ commit }, payload) {
      commit("tokenMutation", payload);
    },
    setSocketConnected({ commit }, payload) {
      commit("setSocketConnectedMutation", payload);
    },
    trackingStationAction({ commit }, payload) {
      commit("trackingStationMutation", payload);
    },
    payapVoidedAction({ commit }, payload) {
      commit("payapVoidedMutation", payload);
    },
    payapAction({ commit }, payload) {
      console.log("payap action");
      commit("payapMutation", payload);
    },
    payapTimeoutAction({ commit }, payload) {
      commit("payapTimeoutMutation", payload);
    },
    payapCancelAction({ commit }, payload) {
      commit("payapCancelMutation", payload);
    },
    payapPaidAction({ commit }, payload) {
      commit("payapPaidMutation", payload);
    },
    setCurrency({ commit }, payload) {
      commit("currencyMutation", payload);
    }
  },
  modules: {},
});
